import { render } from "./ResellerContractsTable.vue?vue&type=template&id=65942ea4&scoped=true"
import script from "./ResellerContractsTable.vue?vue&type=script&lang=js"
export * from "./ResellerContractsTable.vue?vue&type=script&lang=js"

import "./ResellerContractsTable.vue?vue&type=style&index=0&id=65942ea4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65942ea4"]])

export default __exports__